import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

export const templateSlice = createSlice({
  name: "templates",

  initialState,

  reducers: {
    setTemplate: (state, action) => {
      return action.payload
    },
    resetTemplate: () => initialState
  },
});

export const { setTemplate, resetTemplate } = templateSlice.actions;

// export const getTempate = (state) => state;

export default templateSlice.reducer;